import * as XLSX from 'xlsx';

export const BULK_UPLOAD_EXPORT_SEPARATOR = '*** BEGINNING OF EXPORTED DATA ***';

export const writeXLSFile = async (
  fileName = 'File',
  sheets = [],
  write_opts = {}
) => {
  return new Promise(resolve => {
    const workBook = XLSX.utils.book_new();
    sheets.map(sheet => {
      const workSheet = XLSX.utils.json_to_sheet(sheet.data);
      if (sheet.columnConfig) {
        sheet.columnConfig.map(item => {
          workSheet[item.type] = item.value;
        });
      }
      XLSX.utils.book_append_sheet(workBook, workSheet, sheet.name);
    });
    XLSX.writeFile(workBook, `${fileName}`, write_opts);
    resolve(true);
  });
};

export const readXLSFile = (file, options) => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      resolve(workbook);
    };

    reader.onerror = function() {
      resolve(null);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const getFileExtension = name => {
  const lastDot = name.lastIndexOf('.');
  const extension = name.substring(lastDot + 1);
  return extension;
};

export const getFileContent = async (file, options) => {
  let fileData = '';
  switch (getFileExtension(file.name)) {
    case 'xls':
    case 'xlsx':
      fileData = await readXLSFile(file, options);
      break;
    default:
  }

  return fileData;
};

export const getSheetData = (workbook, sheetIdentifier) => {
  if (!(workbook && sheetIdentifier)) {
    return [];
  }

  let sheetToRead = workbook.SheetNames[0];
  if (typeof sheetIdentifier === 'number') {
    sheetToRead = workbook.SheetNames[sheetIdentifier];
  } else {
    sheetToRead = sheetIdentifier;
  }
  let sheetValues = XLSX.utils.sheet_to_json(workbook.Sheets[sheetToRead], {
    defval: null,
    blankrows: false,
    header: 1,
  });

  return sheetValues;
};

export const isExportedTemplate = fileData => {
  const headerIndex = fileData.findIndex(contentRow => {
    if (contentRow.includes(BULK_UPLOAD_EXPORT_SEPARATOR)) {
      return true;
    }

    return null;
  });
  return headerIndex !== -1;
};

export const mapFileContent = (
  fileData = [],
  position = 'Horizontal',
  section = null
) => {
  const mappedData = [];
  let headerIndex = fileData.findIndex((contentRow = []) => {
    const row = contentRow.filter(item => item);
    return row.includes(BULK_UPLOAD_EXPORT_SEPARATOR);
  });

  headerIndex =
    headerIndex !== -1
      ? headerIndex + (isExportedTemplate(fileData) ? 1 : 0)
      : 0;

  const dataLength =
    position === 'Horizontal' ? fileData.length : fileData[0].length;
  const headerKeys =
    position === 'Horizontal'
      ? fileData[headerIndex]
      : fileData.map(row => row[0]);

  for (let index = headerIndex + 1; index < dataLength; index += 1) {
    let rowItem = {};

    headerKeys.map((key, keyIndex) => {
      rowItem = {
        ...rowItem,
        [key]:
          position === 'Horizontal'
            ? fileData[index][keyIndex]
            : fileData[keyIndex][index],
      };

      return null;
    });

    mappedData.push(rowItem);
  }

  if (mappedData.length > 1) {
    return mappedData.filter(
      item =>
        Object.keys(item).filter(i => item[i] && !!item[i].toString().trim())
          .length
    );
  }

  return mappedData;
};